import Container from '@/containers';

const aboutRouter = {
    path: '/about',
    component: Container, 
    name: 'about',
    meta: {
        title: '关于我们'
    },
    children: [
        {
            path: '/about',
            component: () => import('@/views/about'),
            name: 'about',
            meta: {
                title: '关于我们'
            }
        }
    ]
};

export default aboutRouter;